export default __webpack_public_path__ + "static/media/main_logo.93f7f491.svg";